
export const config = {
  apiKey: 'AIzaSyD7K7_2Sqk-iQ5QUdJgmcOJXx-7nhX3FyI',
};
